
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { removeEmpty } from '../utils';
import SearchBar from './SearchBar';
import { BrandSelector, getQuoteUrl, ModelSelector } from './Selectors';


const Finder = (props) => {
    const { t } = useTranslation();

    const [searchModel, setSearchModel] = useState(null);

    const [brand, setBrand] = useState(null);
    const [model, setModel] = useState(null);
    const [version, setVersion] = useState(null);


    const rootEl = document.querySelector("#root");

    const partnerCode = props.partnerCode || rootEl.getAttribute("partner") || undefined;
    const categoryId = props.category || rootEl.getAttribute("category") || undefined;


    const onBrandChange = val => {
        setBrand(val);
        setModel(null);
        setVersion(null);
    };

    const onSearchBarChange = val => {
        setSearchModel(val);


        const redirectUrl = getRedirectUrl(val, categoryId, partnerCode);
        window.location.href = redirectUrl;
    };


    const onModelSelectorChange = val => {
        setModel(val);
        setVersion(null);
        if (!val) {
            return;
        }
        const redirectUrl = getRedirectUrl(val, categoryId, partnerCode);
        window.location.href = redirectUrl;
    };

    const onVersionChange = val => {
        setVersion(val);
        if (!val) {
            return;
        }
        // Define what to do
    };

    const hasSearchBar = props.hasSearchBar !== undefined ? props.hasSearchBar : true;

    const layout = props.layout === "vertical" ? props.layout : "horizontal";

    const colSize = layout === "vertical" ? "col-md-12" : "col-md-6";

    return <div>

        {hasSearchBar ? <>
            <SearchBar onChange={onSearchBarChange} />
            <div className="or-separator text-muted">{t('or')}</div>
        </> : ''}
        <div className="row">
            <div className={colSize}>
                <BrandSelector value={brand} onChange={onBrandChange} />
            </div>
            <div className={colSize}>
                <ModelSelector
                    onChange={onModelSelectorChange}
                    brandId={brand && brand.id}
                    value={model}
                    menuIsOpen={Boolean(brand && brand.id) && !model}
                    isFocused={Boolean(brand && brand.id)}
                    isDisabled={!Boolean(brand)}
                />
            </div>
        </div>
    </div>;

};

const getRedirectUrl = (model, categoryId, partnerCode) => {
    const redirectUrl = model.components_url || getQuoteUrl(model);
    var params = removeEmpty({
        category: categoryId,
        partner: partnerCode,

    });

    const symbol = redirectUrl.includes("?") ? "&" : "?";

    return redirectUrl + symbol + (new URLSearchParams(params)).toString();
};


export default Finder;